/**
 * Dónde descargar la app de autenticación — alta de MFA (`TDS-CORE` DC-09).
 *
 * Enlaces OFICIALES de Google Authenticator, comprobados el 2026-09-17 (las dos
 * páginas responden y son de esa app). Se abren en otra pestaña con
 * `noopener noreferrer`: la tienda no recibe desde qué página se llegó.
 *
 * Iconos PROPIOS (un móvil y una flecha), no los logotipos ni las insignias de
 * Google o Apple: esas son marcas con normas de uso que hay que aceptar al
 * descargarlas. El nombre de la tienda va como texto.
 *
 * Plataforma por `userAgent`, sólo para ORDENAR y reducir ruido: en Android se
 * muestra Google Play, en iPhone/iPad App Store, y en el resto las dos. Si la
 * detección falla, se ven las dos: nunca se esconde la que hacía falta.
 */
import { t } from "../i18n/es";

export const TIENDAS = {
  googlePlay: "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2",
  appStore: "https://apps.apple.com/app/google-authenticator/id388497605",
} as const;

type Plataforma = "android" | "ios" | "otra";

function plataforma(): Plataforma {
  const ua = typeof navigator === "undefined" ? "" : navigator.userAgent;
  if (/Android/i.test(ua)) return "android";
  // iPadOS se presenta como Mac con pantalla táctil.
  if (/iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && typeof document !== "undefined" && "ontouchend" in document)) {
    return "ios";
  }
  return "otra";
}

function IconoDescarga() {
  return (
    <svg className="icono-tienda" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <rect x="6" y="2" width="12" height="20" rx="2.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M12 7v7m-3-3 3 3 3-3" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 18.5h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

function Enlace({ href, tienda }: { href: string; tienda: string }) {
  return (
    <a className="enlace-tienda" href={href} target="_blank" rel="noopener noreferrer">
      <IconoDescarga />
      <span className="enlace-tienda-texto">
        <span className="enlace-tienda-pre">{t.seguridad.descargarEn}</span>
        <span className="enlace-tienda-nombre">{tienda}</span>
      </span>
    </a>
  );
}

export function EnlacesAppAutenticador() {
  const p = plataforma();
  return (
    <div className="tiendas">
      <p className="ayuda-neutra">{t.seguridad.sinApp}</p>
      <div className="tiendas-enlaces">
        {p !== "ios" ? <Enlace href={TIENDAS.googlePlay} tienda={t.seguridad.googlePlay} /> : null}
        {p !== "android" ? <Enlace href={TIENDAS.appStore} tienda={t.seguridad.appStore} /> : null}
      </div>
    </div>
  );
}
